import React, { useEffect, useState } from "react";
import "./QACard.css";

export default function ReferenceCard({ url, apiBase }) {
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!url) return;
    let aborted = false;
    fetch(`${apiBase}/api/ref-preview`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ url }),
    })
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((data) => {
        if (!aborted) setPreview(data);
      })
      .catch(() => {
        if (!aborted) setPreview({ error: true });
      })
      .finally(() => {
        if (!aborted) setLoading(false);
      });
    return () => {
      aborted = true;
    };
  }, [url, apiBase]);

  let fallbackTitle = "Pagina oficială";
  try {
    const parsed = new URL(url);
    const path = parsed.pathname.replace(/\/$/, "");
    const last = path.split("/").filter(Boolean).pop();
    if (last) {
      fallbackTitle = decodeURIComponent(last.replace(/-/g, " "));
      fallbackTitle = fallbackTitle.charAt(0).toUpperCase() + fallbackTitle.slice(1);
    }
  } catch (e) {}

  const title = preview?.title || fallbackTitle;
  const image = preview?.image;

  return (
    <a
      className="qa-reference-card"
      href={url}
      target="_blank"
      rel="noreferrer"
    >
      <div className={`ref-thumb ${!image ? "ref-thumb-fallback" : ""}`}>
        {image ? (
          <img src={image} alt="" loading="lazy" onError={(e) => { e.currentTarget.style.display = "none"; }} />
        ) : (
          <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
            <path d="M12 2L2 7v10l10 5 10-5V7L12 2zm0 2.18L19.5 8 12 11.82 4.5 8 12 4.18zM4 9.41l7 3.5v7.82L4 17.18V9.41zm9 11.32v-7.82l7-3.5v7.77l-7 3.55z"/>
          </svg>
        )}
      </div>
      <div className="ref-body">
        <div className="ref-domain">rogen.umfcd.ro</div>
        <div className="ref-title">{loading ? "…" : title}</div>
      </div>
    </a>
  );
}
